import { Box } from '@mui/material';

const masterColumn = () => [
  {
    field: 'userEmail',
    headerName: 'User Email',
    width: 300,
    editable: false,
    headerAlign: 'center',
    align: 'center',
    hide: false,
  },
  {
    field: 'sRig',
    headerName: 'sRig',
    width: 250,
    editable: false,
    headerAlign: 'center',
    align: 'center',
    hide: false,
  },
  {
    field: 'sJobId',
    headerName: 'sJobId',
    width: 250,
    editable: false,
    headerAlign: 'center',
    align: 'center',
    hide: false,
  },
  {
    field: 'lat',
    headerName: 'Latitute',
    width: 200,
    editable: false,
    headerAlign: 'center',
    align: 'center',
    hide: false,
  },
  {
    field: 'long',
    headerName: 'Longitude',
    width: 200,
    editable: false,
    headerAlign: 'center',
    align: 'center',
    hide: false,
  },
  {
    field: 'comment',
    headerName: 'Comment',
    width: 500,
    editable: false,
    headerAlign: 'center',
    align: 'center',
    hide: false,
    renderCell: (params) => (
      <Box whiteSpace='wrap'>
        {params.value}
      </Box>
    )
  },
];

export { masterColumn };
